import { useOnceEffect } from "@/utils/hooks";
import { useState } from "react";
import { CarouselContext } from "./context";

interface ProviderProps {
  children: React.ReactNode;
  itemCount: number;
  visible?: number;
}

export function CarouselProvider({
  children,
  itemCount,
  visible = 5,
}: ProviderProps) {
  const clampedVisible = Math.max(1, Math.min(visible, itemCount));
  const [index, setIndex] = useState(0);
  const maxIndex = Math.max(0, itemCount - clampedVisible);

  useOnceEffect(() => setIndex((index) => Math.min(index, maxIndex)));

  const previous = () => setIndex((index) => Math.max(0, index - 1));
  const next = () => setIndex((index) => Math.min(maxIndex, index + 1));

  return (
    <CarouselContext.Provider
      value={{ previous, next, index, maxIndex, visible: clampedVisible }}
    >
      {children}
    </CarouselContext.Provider>
  );
}
